import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { UserService } from '../../services/user.service';
import { NavigationService, CampusUnitsMessageService } from '../../services';
import { CampusUnitMessage } from '../../models/notifications/campus-unit-message.model';
import { Router } from '@angular/router';

@Component({
  selector: 'app-toolbar',
  templateUrl: './toolbar.component.html',
  styleUrls: ['./toolbar.component.scss']
})
export class ToolbarComponent implements OnInit {
  @Output() toggleMenu: EventEmitter<any> = new EventEmitter();
  showNotification = false;
  activeMessages: Array<CampusUnitMessage> = [];
  currentMessage = '';
  notificationsLoaded = false;

  navigationService: NavigationService = null;
  userService: UserService = null;

  constructor(
    navigationService: NavigationService,
    private messageService: CampusUnitsMessageService,
    private user: UserService,
    private route: Router
  ) {
    this.navigationService = navigationService;
    this.route.events.subscribe(u => {
      if (this.canShowNotifications() && !this.notificationsLoaded) {
        this.loadActiveNotifications();
        this.notificationsLoaded = true;
        this.userService = user;
      }
    });
  }

  ngOnInit() {
    if (this.canShowNotifications()) {
      this.loadActiveNotifications();
    }
  }

  canShowNotifications() {
    // const isAdmin = this.navigationService.loggedInAsAdmin();
    // const isLeader = this.navigationService.loggedInAsLeader();
    // const isStakeLeader = this.navigationService.loggedInAsStake();
    // // const isWard = this.navigationService.loggedInAsWard;

    // return isLeader || isStakeLeader || isAdmin;
    if (
      this.navigationService.loggedInAsLeader() ||
      this.navigationService.loggedInAsAdmin()
    ) {
      return true;
    }
    return false;
  }

  /**
   * Emits our toggle menu event.
   */
  toggle(): void {
    this.toggleMenu.emit(null);
  }

  loadActiveNotifications() {
    this.messageService.getActiveMessages().subscribe(result => {
      if (result) {
        this.activeMessages = result;
        this.activeMessages.sort(this.compareNotificationsDesc);
        this.setCurrentMessage();
        if (result && result.length > 0) {
          this.showNotification = true;
        }
      } else {
        this.showNotification = false;
      }
    });
  }

  getCurrentNotificationMessage() {
    if (this.activeMessages) {
      return this.activeMessages[0].message;
    }
  }

  /**
   * Compare notifications in descending order
   * @param a first notification
   * @param b second notification
   */
  compareNotificationsDesc(a: CampusUnitMessage, b: CampusUnitMessage): number {
    if (a.startDate > b.startDate) {
      return -1;
    }

    if (a.startDate < b.startDate) {
      return 1;
    }

    return 0;
  }

  onDismissNotification() {
    if (this.activeMessages) {
      this.activeMessages.splice(0, 1);
      this.setCurrentMessage();
    }

    if (this.activeMessages.length <= 0) {
      this.showNotification = false;
    }

    // prevent the page from reloading
    return false;
  }

  setCurrentMessage() {
    this.currentMessage = this.activeMessages[0]
      ? this.activeMessages[0].message
      : '';
  }
}
